// @ts-nocheck
import { field } from '../claim.fields';

export function getValues() {
	let obj: {}[] = [];
	field.fields.forEach((mainFields) => {
		const { context } = field;
		if (mainFields.value && mainFields.entityKey)
			obj = { ...obj, [mainFields.entityKey]: mainFields.value, ...{ context } };
		else {
			if (mainFields.type === 'ADDITIONAL_VALUES') {
				mainFields?.fields?.forEach((groups) => {
					obj = { ...obj, [groups.entityKey]: groups.enabled || false };
					groups.fields.forEach((items) => {
						items.forEach((item) => {
							if (item.value && item.entityKey) obj = { ...obj, [item.entityKey]: item.value };
						});
					});
				});
			}
		}
	});

	return obj;
}

export function getField() {
	let obj;

	if (!obj) {
		field.fields.map((item) => {
			if (item.entityKey) {
				obj = { ...obj, [item.entityKey]: item };
			}
		});
	}

	return obj;
}

export function clearFields() {
	field.fields.forEach((mainFields: any) => {
		if (mainFields.entityKey !== 'oldPhases') {
			mainFields.value = null;
			mainFields.error = [];
			if (mainFields.type === 'ADDITIONAL_VALUES') {
				mainFields.fields.forEach((groups, index) => {
					groups.error = [];
					groups.enabled = index === 0 ? true : false;
					groups.fields.forEach((items) => {
						items.forEach((item: any) => {
							item.error = [];
							item.value = null;
						});
					});
				});
			}
		}
	});
}
